import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export const businessRoutes = [
  {
    path: 'business',
    name: 'Business',
    component: () => import('@/views/Business/Business.vue'),
    meta: {
      title: `${t('business')} | Pour Now`,
    },
  },
]
